import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';

const NewsFolderView = (props) => {
  const { content } = props;
  const { pathname } = useLocation();
  const path = getBaseUrl(pathname || '');

  return (
    <>
      <Helmet>
        <title>{content.title}</title>
        {content.description ? (
          <meta name="description" content={content.description} />
        ) : null}
        {content['@id'] ? (
          <link rel="canonical" href={flattenToAppURL(content['@id'])} />
        ) : null}
      </Helmet>
      <Container id="news-folder">
        <RenderBlocks {...props} path={path} />
      </Container>
    </>
  );
};

NewsFolderView.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default NewsFolderView;
